module.exports = __webpack_public_path__ + "static/media/premium.5c9f6d53.png";